module.exports = __webpack_public_path__ + "img/goods2-4.ac61e8ca.jpg";